import { environment } from '../../environments/environment';

export const apiEndpoint = environment.data.baseUrl;
